import * as PIXI from "pixi.js-legacy";

import CommanderBase from "../framework/src/commander/CommanderBase";
import events from "../framework/src/events/EventsObservable";
import States from "./States";

import InfoPages from "./InfoPages";
import Emitter from "./Emitter.js";
import TouchZone from "./TouchZone.js";
import IdleAnimations from "./animations/IdleAnimations.js";
import BigWin from "./BigWin.js";
import WinLines from "./WinLines";
import NormalWin from "./animations/NormalWin";
import WildWin from "./animations/WildWin";
import SymbolAnimations from "./animations/SymbolAnimations";
import LineWinAnimations from "./animations/LineWinAnimations";
import IdleWinAnimations from "./animations/IdleWinAnimations";
import Counter from "./animations/Counter.js";

import { GAME_EVENTS } from "../framework/src/game/gameEvents";
import { WALLET_EVENTS } from "../framework/src/wallet/Wallet";
import { REELS_EVENTS } from "../framework/src/game/slot/reelsEvents";
import { CONFIG_PARAMS } from "../framework/src/system/SystemConfig";
import {
	pixiSetTimeout,
	pixiSetTimeoutAsync,
} from "../framework/src/engine/pixi/pixiTimeout";
import { STATES } from "../framework/src/states/states";
import IInfoPages from "../framework/src/engine/IInfoPages";
import SERVICE_IDENTIFIER from "../framework/src/constants/identifiers";
import Frames from "./Modules/Frames";
import { removeSprite } from "../framework/src/modules/Sprite";
import AbstractIframePage from "../framework/src/engine/AbstractIfarmePage";
import MobileDOM from "../framework/src/ui/mobile/MobileDOM";
import DesktopDOM from "../framework/src/ui/desktop/DesktopDOM";
import BaseDOM from "../framework/src/ui/BaseDOM";
import IDOM from "../framework/src/ui/IDOM";
import {PLATFORM} from "../framework/src/system/SystemPlatform";

/**
 *
 *
 * @extends CommanderBase
 * @class
 */
class Commander extends CommanderBase {
	touchZone: TouchZone;
	slots: any;
	layers: any;

	WinLines: WinLines;
	Emitter: Emitter;

	IdleAnimations: IdleAnimations;

	SymbolAnimations: SymbolAnimations;
	LineWinAnimations: LineWinAnimations;
	IdleWinAnimations: IdleWinAnimations;
	NormalWin: NormalWin;
	WildWin: WildWin;
	BigWin: BigWin;
	Counter: Counter;
	dom: IDOM

	previousState: string;
	currentState: string;
	currentResult: any;

	winCounter: number;
	respinWin: number;
	respinsIndex: number;
	lineWinsIndex: number;
	spreadCount: number;
	skipAnim: boolean;
	bgMusicTimeout: number;

	inRespin: boolean;
	animColorFilter: any;

	infopages: AbstractIframePage;
	paragraph: AbstractIframePage;

	constructor(system, game, engine) {
		super(system, game, engine);

		this.slots = game.gameCore.slots;

		// @ts-ignore
		this.layers = this.app.layers.getAllLayers();

		//this.lineWinIndex = 0;
		this.respinsIndex = 0;
		// @ts-ignore
		window.commanderXD = this;
	}

	/**
	 * Initialize states, touchzone and all the modules for animations. Creates Logo, Top and black sprites.
	 * @override
	 */
	create(container) {
		super.create(container);

		// this.initVisibility();
		createjs.MotionGuidePlugin.install(); // without this moving on a bezier curve is not working

		Frames.init();

		// @ts-ignore
		this.infopages = container.get<AbstractIframePage>(
			SERVICE_IDENTIFIER.InfoPages
		);
		this.infopages.create();
		// @ts-ignore
		this.paragraph = container.get<AbstractIframePage>(
			SERVICE_IDENTIFIER.ParagraphPage
		);
		this.paragraph.create();

		this.touchZone = new TouchZone(
			this.config,
			this.layers,
			this.slots,
			this.wallet,
			this.symbols,
			this.audio,
			this.infopages
		);

		this.WinLines = new WinLines(this);
		this.WinLines.init();
		// @ts-ignore
		this.Emitter = new Emitter(this.app.renderer, this);
		this.Emitter.create(this.layers.emitter);

		this.IdleAnimations = new IdleAnimations(this);

		this.SymbolAnimations = new SymbolAnimations(this);
		this.LineWinAnimations = new LineWinAnimations(this);
		this.IdleWinAnimations = new IdleWinAnimations(this);
		this.NormalWin = new NormalWin(this);
		this.WildWin = new WildWin(this);
		this.BigWin = new BigWin(this);
		this.Counter = new Counter(
			this.layers,
			this.wallet,
			this.BigWin,
			this.audio
		);

		// @ts-ignore
		this.dom = container.get<IDOM>(SERVICE_IDENTIFIER.DOM);
		if (this.config.get(CONFIG_PARAMS.LEGISLATION) === "it") {
			if (this.config.get(CONFIG_PARAMS.UI_DEVICE) === PLATFORM.DESKTOP) {
				(this.dom as DesktopDOM).showRespins()
			} else {
				(this.dom as MobileDOM).showRespins()
			}
		}

		this.previousState = "idle";
		this.currentState = "idle";
		this.currentResult = undefined;

		this.winCounter = 0;
		this.respinWin = 0;
		this.respinsIndex = 0;
		this.lineWinsIndex = 0;
		this.spreadCount = 0;
		this.skipAnim = false;

		this.inRespin = false;

		this.onInit();

		events.subscribe(
			GAME_EVENTS.GAME_ADD_RESULT,
			(eventName, { addResult, symbolsMatrix }) => {
				this.slots.reels.getReels().forEach((reel, i) => {
					if (reel.data.wild) {
						symbolsMatrix[i].forEach((symbol) => {
							symbol.visible = false;
						});
					}
				});
			}
		);
		events.subscribe(REELS_EVENTS.REELS_START, (eventName, data) => {
			if (!this.inRespin) this.showResSymbols();
		});
	}

	notify(eventName, data) {
		switch (eventName) {
			case WALLET_EVENTS.WALLET_ON_SET_BET:
				this.touchZone.updateBet();
				break;
		}

		super.notify(eventName, data);
	}

	skip() {
		this.skipAnim = true;
		this.Counter.skip();
	}

	onInit() {
		this.initImages();
		this.setReelsMask();
		this.initStates();
		this.addInfoPages();
		this.IdleWinAnimations.init();
		this.BigWin.init();
		this.IdleAnimations.init();
		this.SymbolAnimations.init();

		this.audio.playTrack("bg_Music");
		// @ts-ignore
		this.audio.fadeToTrack("bg_Music", 7, 1000);

		this.animColorFilter = new PIXI.filters.ColorMatrixFilter();
		this.layers.emitter.filters = [this.animColorFilter];
		this.layers.win.children[4].filters = [this.animColorFilter];
		this.Counter.init(this.animColorFilter);
		this.handleState();
	}

	setBgMusicTimeout() {
		this.clearBgMusicTimeout();
		this.bgMusicTimeout = setTimeout(() => {
			// @ts-ignore
			this.audio.fadeToTrack("bg_Music", 3, 5000);
		}, 20000);
	}

	clearBgMusicTimeout() {
		clearTimeout(this.bgMusicTimeout);
	}

	setState(newState) {
		this.cleanUp().then(() => {
			this.previousState = this.currentState;
			this.currentState = newState;
			// console.warn("new",this.currentState,"old",this.previousState);
			this.handleState();
		});
	}

	handleState() {
		switch (this.currentState) {
			case "idle":
				if (
					this.previousState === "wildWin" ||
					this.previousState === "respin"
				) {
					this.WildWin.cleanUp();
					this.WildWin.removeWildSymbols();
				}
				this.setBgMusicTimeout();
				this.touchZone.zonesOn();
				this.currentResult = undefined;
				this.IdleAnimations.run();
				this.showResSymbols();
				break;
			case "spin":
				this.audio.playTrack("reel_Start");
				this.showResSymbols();
				this.WinLines.circleSpinAnimation();
				this.IdleWinAnimations.cleanUp();
				Commander.setAlpha(this.layers.black, 0, 100);
				this.touchZone.zonesOff();
				this.touchZone.hide();
				break;
			case "bigWin":
				this.SymbolAnimations.lightenReels();
				this.SymbolAnimations.drawWinSymbols(this.currentResult);
				this.BigWin.run(this.currentResult).then(() => {
					this.setWin(this.currentResult.win);
					this.setStateByLineWin(
						this.currentResult.lineWins[this.lineWinsIndex]
					);
				});
				break;
			case "normalWin":
				this.states.setState(STATES.SKIP);
				this.SymbolAnimations.drawWinSymbols(this.currentResult);
				this.SymbolAnimations.darkenReels();
				this.Counter.run(
					this.currentResult.win,
					this.currentResult.lineWins.length
				);
				this.NormalWin.run(this.currentResult.lineWins).then(() => {
					this.setWin(this.currentResult.win);
					pixiSetTimeout(0.4, () => {
						this.setStateByLineWin(
							this.currentResult.lineWins[this.lineWinsIndex]
						);
					});
				});
				break;
			case "spread":
				this.inRespin = true;
				this.BigWin.changeColor();
				this.incRespin();
				this.game.round.incResultIndex();
				this.spreadCount++;
				this.lineWinsIndex++;
				this.WildWin.spread(this.getSpreadLineWin().position).then(() => {
					if (this.isMegaWin()) this.setState("wildBigWin");
					else this.setState("wildWin");
				});
				break;
			case "wildWin":
				this.SymbolAnimations.drawWinSymbols(
					this.currentResult,
					this.respinsIndex
				);
				let lineWins = this.getRespinLineWins();
				if (lineWins && lineWins.length > 0 && lineWins[0].type !== "respin")
					this.SymbolAnimations.darkenReels();
				else this.SymbolAnimations.lightenReels();
				this.Counter.run(this.getWinFromLineWins(lineWins), lineWins.length);
				this.WildWin.run(lineWins).then(() => {
					pixiSetTimeout(0.4, () => {
						this.setStateByLineWin(
							this.currentResult.lineWins[this.lineWinsIndex]
						);
					});
				});
				break;
			case "wildBigWin":
				this.SymbolAnimations.lightenReels();
				this.SymbolAnimations.drawWinSymbols(
					this.currentResult,
					this.respinsIndex
				);
				this.BigWin.run(this.currentResult, true).then(() => {
					this.SymbolAnimations.darkenReels();
					this.setStateByLineWin(
						this.currentResult.lineWins[this.lineWinsIndex]
					);
				});
				break;
			case "respin":
				this.states.setState(STATES.SPIN);
				this.incRespin();
				this.updateRespins()
				this.lineWinsIndex++;
				this.WinLines.circleSpinAnimation();
				this.audio.playTrack("reel_Start_Wild");
				this.SymbolAnimations.lightenReels();
				this.WildWin.respin(this.currentResult).then(() => {
					this.setStateByLineWin(
						this.currentResult.lineWins[this.lineWinsIndex]
					);
				});
				break;
			case "idleWin":
				this.IdleWinAnimations.run(this.currentResult);
				this.touchZone.zonesOn();
				if (
					this.previousState === "wildWin" ||
					this.previousState === "wildBigWin"
				) {
					this.SymbolAnimations.drawWinSymbols(
						this.currentResult,
						this.respinsIndex,
						true
					);
					this.SymbolAnimations.drawWildSymbols();
				}
				break;
		}
	}

	setStateByLineWin(lineWin) {
		if (lineWin) {
			if (lineWin.type === "spread") {
				this.setState("spread");
			} else if (lineWin.type === "respin") {
				this.setState("respin");
			} else if (lineWin.type === "normal") {
				if (this.isBigWin()) {
					this.setState("bigWin");
				} else {
					this.setState("normalWin");
				}
			} else if (lineWin.type === "wild") {
				if (this.isMegaWin()) {
					this.setState("wildBigWin");
				} else {
					this.setState("wildWin");
				}
			} else {
				this.endRound();
			}
		} else {
			this.endRound();
		}
	}

	getRespinLineWins(respinIndex = this.respinsIndex, bigwin = false) {
		let lineWins = [];
		let index = 0;
		if (this.currentResult.lineWins === undefined) return [];
		else {
			for (let lineWin of this.currentResult.lineWins) {
				if (lineWin.type === "respin" || lineWin.type === "spread") {
					if (!bigwin && respinIndex === index) lineWins.push(lineWin);
					index++;
				} else if (respinIndex === index) lineWins.push(lineWin);
			}
			return lineWins;
		}
	}

	getWinFromLineWins(lineWins) {
		let win = 0;
		for (let line of lineWins) {
			if (line.win) win += line.win;
		}
		return win;
	}

	// clean up after certain state
	async cleanUp() {
		switch (this.currentState) {
			case "idle":
				this.IdleAnimations.stop();
				break;
			case "spin":
				this.lineWinsIndex = 0;
				break;
			case "normalWin":
				this.skipAnim = false;
				break;
			case "spread":
				break;
			case "bigWin":
				break;
			case "wildWin":
				this.skipAnim = false;
				break;
			case "wildBigWin":
				break;
			case "respin":
				break;
			case "idleWin":
				this.showResSymbols();
				this.WildWin.layer.anim.removeChildren();
				this.WildWin.removeWildSymbols();
				this.IdleWinAnimations.cleanUp();
				this.SymbolAnimations.removeWinSymbols();
				this.SymbolAnimations.lightenReels();
				break;
		}
	}

	controlResult(result) {
		this.currentResult = result;
		if (result.lineWins && result.lineWins.length) {
			this.setStateByLineWin(result.lineWins[0]);
		} else {
			this.endRound();
		}
	}

	// returns the factors of a symbol given by name
	getSymbolFactor(name) {
		return this.config
			.get(CONFIG_PARAMS.SYMBOL_DEFINITION)
			.find((symbols) => symbols.name === name);
	}

	onSpinStart() {
		// this.showResSymbols();
		if (!this.inRespin) {
			pixiSetTimeout(1, () => {
				this.Counter.hide();
			});
			this.setState("spin");
		}
		this.clearBgMusicTimeout();
		if (
			this.audio.getVolume("bg_Music") !==
			this.audio.getDefaultVolume("bg_Music")
		) {
			// @ts-ignore
			this.audio.fadeToTrack("bg_Music", 1, 2000);
		}
		this.SymbolAnimations.removeWinSymbols();
	}

	/**
	 * Call {@link CommanderBase#endRound} to tell server round has ended. After that
	 * clean up after animations and run Idle animation or start autospin, toggle arrows and touchzones.
	 * Reset values for animations and set win.
	 * @param result
	 */
	onEndRoundRecalced({ autorun }) {
		this.animColorFilter.hue(184 - 39, false);
		this.WildWin.cleanUp();
		pixiSetTimeout(0.4, () => {
			this.LineWinAnimations.cleanUp();
		});
		this.inRespin = false;
		this.BigWin.removeColor();
		this.resetRespin();
		if (autorun) {
			this.showWildReels();
			this.showResSymbols();
			this.WildWin.layer.anim.removeChildren();
			this.WildWin.removeWildSymbols();
			this.SymbolAnimations.lightenReels();
		} else {
			this.setState("idleWin");
		}
	}

	isBigWin() {
		let bet = this.wallet.getTotalBet();
		this.respinWin = Commander.getRespinWin(
			this.respinsIndex,
			this.currentResult.lineWins
		);

		return (
			this.respinWin / bet >= this.config.get(CONFIG_PARAMS.BIG_WIN_FACTOR)
		);
	}

	isMegaWin() {
		let bet = this.wallet.getTotalBet();
		this.respinWin = Commander.getRespinWin(
			this.respinsIndex,
			this.currentResult.lineWins
		);

		return (
			this.respinWin / bet >= this.config.get(CONFIG_PARAMS.MEGA_WIN_FACTOR)
		);
	}

	incRespin() {
		this.respinsIndex++;
	}

	resetRespin() {
		this.respinsIndex = 0;
		this.spreadCount = 0;
		this.updateRespins()
	}

	getSpreadLineWin() {
		let spreadCnt = 0;
		for (let lineWin of this.currentResult.lineWins) {
			if (lineWin.type === "spread") {
				spreadCnt++;
				if (this.spreadCount === spreadCnt) {
					return lineWin;
				}
			}
		}
		return undefined;
	}

	showResSymbols() {
		for (let reel of this.slots.getReels()) {
			for (let symbol of reel.getResSymbols()) {
				symbol.visible = true;
				symbol.alpha = 1;
				this.layers.reels.addChild(symbol);
			}
		}
	}

	showWildReels() {
		for (let reel of this.slots.getReels()) {
			reel.data.wild = false;
		}
	}

	updateRespins(): void {
		if (this.config.get(CONFIG_PARAMS.LEGISLATION) !== "it") return
		if (this.config.get(CONFIG_PARAMS.UI_DEVICE) === PLATFORM.DESKTOP) {
			(this.dom as DesktopDOM).updateRespins(this.respinsIndex-1, 3)
		} else {
			(this.dom as MobileDOM).updateRespins(this.respinsIndex-1, 3)
		}
	}

	static blurSymbol(symbol) {
		symbol.texture = PIXI.Texture.from(
			symbol.name.replace("_blur", "") + "_blur.png"
		);
		return symbol;
	}

	static unblurSymbol(symbol) {
		symbol.name = symbol.name.replace("_blur", "");
		symbol.texture = PIXI.Texture.from(symbol.name + ".png");
		return symbol;
	}

	// ______________________________________________
	// INITIALIZATION METHODS
	initImages() {
		let logo = new PIXI.AnimatedSprite(Frames.logo);
		logo.anchor.set(0.5, 0);
		logo.position.set(640, 0);
		logo.loop = false;
		logo.animationSpeed = 0.4;
		this.layers.logo.addChild(logo);

		let blackBg = new PIXI.Graphics();
		blackBg.beginFill(0x000000);
		blackBg.drawRect(0, 0, 1280, 720);
		blackBg.endFill();
		this.layers.black.addChild(blackBg);
		this.layers.black.alpha = 0;
	}

	setReelsMask() {
		let mask = Commander.getSprite("mask_reels.png", 0, 30, { x: 0, y: 0 });
		// @ts-ignore
		this.app.getStage().addChild(mask);
		this.layers.reels.mask = mask;
	}

	initStates() {
		let states = new States(this);
		events.subscribe(GAME_EVENTS.GAME_SPIN_START, () => this.onSpinStart());
		events.subscribe(GAME_EVENTS.GAME_END_ROUND_RECALCED, (eventName, data) =>
			this.onEndRoundRecalced(data)
		);

		events.subscribe(REELS_EVENTS.REEL_SPIN, (eventName, data) =>
			states.spin.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_BRAKEDOWN, (eventName, data) =>
			states.brakeDown.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_ACC_UP, (eventName, data) =>
			states.accUp.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_ACC_DOWN, (eventName, data) =>
			states.accDown.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_STOP, (eventName, data) =>
			states.stop.call(this, data)
		);
		events.subscribe(REELS_EVENTS.REEL_STOPPING, (eventName, data) =>
			states.stopping.call(this, data)
		);

		events.subscribe(WALLET_EVENTS.WALLET_ON_SET_BET, this);
	}

	addInfoPages() {
		// @ts-ignore
		// this.infoPages.addInfoPages(this.app, this.touchZone);
	}

	// initVisibility() {
	//     if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
	//         this.hidden = "hidden";
	//         this.visibilityChange = "visibilitychange";
	//     } else if (typeof document.msHidden !== "undefined") {
	//         this.hidden = "msHidden";
	//         this.visibilityChange = "msvisibilitychange";
	//     } else if (typeof document.webkitHidden !== "undefined") {
	//         this.hidden = "webkitHidden";
	//         this.visibilityChange = "webkitvisibilitychange";
	//     }
	//     document.addEventListener(this.visibilityChange, this.handleVisibilityChange.bind(this), false);
	// }

	handleVisibilityChange() {}

	// _______________________________________________
	// STATIC METHODS
	static getRespinWin(respin, lineWins) {
		let win = 0;
		let index = 0;
		for (let lineWin of lineWins) {
			if (lineWin.type === "respin" || lineWin.type === "spread") index++;
			else if (respin === index) win += lineWin.win;
		}
		return win;
	}

	static getSprite(name, x, y, anchor = { x: 0.5, y: 0.5 }) {
		let sprite = new PIXI.Sprite(PIXI.Texture.from(name));
		sprite.anchor.set(anchor.x, anchor.y);
		sprite.position.set(x, y);
		return sprite;
	}

	static getTween(
		obj,
		to,
		time,
		eventL = () => {},
		cb = () => {},
		ease = createjs.Ease.linear
	) {
		Commander.removeTween(obj);
		let tween = createjs.Tween.get(obj)
			.to(to, time, ease)
			.call(() => {
				Commander.removeTween(obj);
				cb();
			})
			.addEventListener("change", eventL);
	}

	static getTweenAsync(
		obj,
		to,
		time,
		eventL = () => {},
		ease = createjs.Ease.linear
	) {
		return new Promise<void>((res) => {
			Commander.removeTween(obj);
			let tween = createjs.Tween.get(obj)
				.to(to, time, ease)
				.call(() => {
					Commander.removeTween(obj);
					res();
				})
				.addEventListener("change", eventL);
		});
	}

	static removeTween(sprite) {
		createjs.Tween.removeTweens(sprite);
	}

	static setAlpha(obj, value, time) {
		this.removeTween(obj);
		createjs.Tween.get(obj)
			.to({ alpha: value }, time)
			.call(() => this.removeTween(obj));
	}
}
export default Commander;
